export const BILL_DEADLINE_START = 1
export const BILL_DEADLINE_END = 10
